module.exports = __webpack_public_path__ + "img/brazo-extensor-4.c55e33ec.png";